import React from 'react';
import { withSkeleton } from '../../AppTable/helpers/withSkeleton';
import { ICCUser, UniqueId } from '@communication-center/data-objects';

interface IEmail {
    rowData: { id: UniqueId; label: ICCUser };
    testId?: string;
    classes?: {
        root: string;
    };
}

const Email = ({ rowData: data, classes, testId = 'email' }: IEmail) => {
    return (
        <div className={classes?.root} data-testid={`${data.id}-${testId}`}>
            {typeof data.label === 'string' ? data.label : data.label.email}
        </div>
    );
};

export default withSkeleton({ height: 12, width: 90 })(Email);
